// Trigger a browser download of in-memory text via a Blob object URL. Replaces
// the old `data:` URI approach, which has length limits.

export function downloadTextFile(
  filename: string,
  text: string,
  mimeType = 'text/csv;charset=utf-8',
): void {
  const blob = new Blob([text], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
